<template>
  <div class="kp-modular-row">
    <span><i class="kp-panel-jump"></i>{{$t('general.labels.jump')}}</span>
    <div class="pull-right">
      <add-button></add-button>
      <remove-button :index="index" :jump-id="jumpId"></remove-button>
    </div>
  </div>
</template>

<script>
import AddButton from './buttons/Add.vue';
import RemoveButton from './buttons/Remove.vue';

export default {
  props: [
    'index',
    'jumpId',
  ],
  components: {
    AddButton,
    RemoveButton,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Header.vue?6bf07f03
 **/